import { Link, Route, Routes, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './App.css';

import HomeDashboard from "./pages/SpearParts/Home/Dashboard";
import { SearchOption } from "./pages/SearchOption";
import { Header } from './components/SpearParts/Layouts/Header';
import { Footer } from './components/SpearParts/Layouts/Footer';
import { ProductCategory } from "./pages/Product/ProductCategory";
import ProductPage from "./pages/Product/SingleProduct";
import { About } from './pages/About/About';
import ContactUs from "./pages/ContactUs";

import CustomerReview from "./pages/CustomerReview"

  import { ToastContainer } from 'react-toastify';


import { AccountHome } from "./pages/Accounts/AccountHome";
import Orders from "./pages/Accounts/Orders";
import OrderDetails from "./pages/Accounts/OrderDetails";
import ContactInformation from "./pages/Accounts/ContactInformation";
import PaymentOptions from "./pages/Accounts/PaymentOptions";
import PaymentList from "./pages/Accounts/PaymentList";
import PurchaseHistory from "./pages/Accounts/PurchaseHistory";
import Login from "./pages/Accounts/Login";
import SignUp from "./pages/Accounts/SignUp";
import ProductList from "./pages/Product/ProductList";
import SingleProduct from "./pages/Product/SingleProduct";
import Category from "./pages/Product/Category";
import Product from "./pages/Product/Product";
import ViewCart from "./pages/Product/ViewCart";
import PartsModal from "./components/SpearParts/Layouts/PartsModal";
import SupplierOrdersPage from "./components/Supplier/Admin/SupplierOrdersPage";
import ProductReports from "./components/Supplier/Admin/ProductReports";
import OthersSubcategory from "./pages/Others/Product/OthersSubcategory";
 



import Refer from "./pages/Product/refer";
import 'react-toastify/dist/ReactToastify.css'; // Import Toastify's CSSnpm install react-toastify

 
import Delivery from "./pages/Accounts/Cart/Delivery";
import EngineeringHome from "./pages/Engineering/Home/EngineeringHome";
import EngProductList from "./pages/Engineering/Products/EngProductList";
import EngSingleProduct from "./pages/Engineering/Products/EngSingleProduct";
import OthersProductList from "./pages/Others/Product/OthersProductList";
import OthersSingleProduct from "./pages/Others/Product/OthersSingleProduct";
import OtherHome from "./pages/Others/Home/OtherHome";
import RentalHome from "./pages/Rental/Home/RentalHome";
import RentalCategory from "./pages/Rental/Product/RentalCategory";

import OtherCategory from "./pages/Others/Product/OthersCategory";


import EngineeringCategory from "./pages/Engineering/Products/EngineeringCategory";
import ForgotPswd from "./pages/Accounts/ForgotPswd";
import PurchaseOrder from "./pages/Accounts/PurchaseOrder";

import OrderPdf from './pages/Accounts/OrderPdf'
import Products from "./components/SpearParts/Layouts/Products";
import SupplierPaymentList from "./components/Supplier/Admin/SupplierPaymentList";

//suplier

import SupplierDashboard from "./components/Supplier/Admin/SupplierDashboard";
import SupplierProducts from "./components/Supplier/Admin/SupplierProducts";
import SupplierReports from "./components/Supplier/Admin/SupplierReports";
import SupplierPayments from "./components/Supplier/Admin/SupplierPayments";
import SupplierOrders from "./components/Supplier/Admin/SupplierOrders";
import SupplierReturns from "./components/Supplier/Admin/SupplierReturn";
import CustomerReports from "./components/Supplier/Admin/CustomerReports";

import SupplierNavbar from "./components/Supplier/Admin/SuppplierNavbar";
import SupplierSidebar from "./components/Supplier/Admin/SupplierSidebar";

import SupplierSignup from "./components/Supplier/SupplierSignup";
import CreateEngProduct from "./components/Supplier/ProductCreation/CreateEngProduct";
import CreateSpareProduct from "./components/Supplier/ProductCreation/CreateSpareProduct";
import CreateBldProduct from "./components/Supplier/ProductCreation/CreateBldProduct";
import EngEdit from "./components/Supplier/ProductEdit/EngEdit";
import SpareEdit from "./components/Supplier/ProductEdit/SpareEdit";
import BldEdit from "./components/Supplier/ProductEdit/BldEdit";
import CreateRentalProduct from "./components/Supplier/ProductCreation/CreateRentalProduct";
import RentalEdit from "./components/Supplier/ProductEdit/RentalEdit";
import SupplierSingleOrder from "./components/Supplier/Admin/SupplierSingleOrder";
import SupplierLogin from "./components/Supplier/SupplierLogin";
import RentalProductList from "./pages/Rental/Product/RentalProductList";
import RentalSingleProductPage from "./pages/Rental/Product/RentalSingleProduct";
import LoadingPage from "./components/Loader/LoadingPage";
import SubCategory from "./pages/Product/Subcategory";
import SubcategoryPage from "./pages/Others/Product/OthersSubcategory";
import RentalSubCategory from "./pages/Rental/Product/RentalSubCategory";
import EngineeringSubcategory from "./pages/Engineering/Products/EngineeringSubcategory";
import NewDashboard from "./pages/SpearParts/Home/NewDashboard";
import NewEngineeringHome from "./pages/Engineering/Home/NewEngineeringHome";
import BuildingHome from "./pages/Others/Home/BuildingHome";
import NewRentalHome from "./pages/Rental/Home/NewRentalHome";



function App() {

  const navigate = useNavigate(); // Import useNavigate hook
  const currentLocation = useLocation();
  const [businessType, setBusinessType] = useState(sessionStorage.getItem("businessType") || "");
  const [showModal, setShowModal] = useState(!businessType); // Show modal only if businessType is empty
  // const noHeaderFooterRoutes = ["/SupplierDashboard", "/SupplierProducts" , "/SupplierReports", "/SupplierPayments","/engproduct","/spareproduct","/bldproduct","/engedit/:id","/spare-edit/:id","/bldedit/:id"];


  const [isLoading, setIsLoading] = useState(true);
  
// Exact paths (no dynamic segments)
const noHeaderFooterRoutes = [
  "/SupplierDashboard",
  "/SupplierProducts",
  "/SupplierReports",
  "/SupplierPayments",
  "/engproduct",
  "/spareproduct",
  "/bldproduct",
  "/supplier/orders",
  "/supplierOrders",
  "/productReports",
  "/SupplierReturns",
  "/CustomerReports",
   "/supplier/payments-list",
   "/rentalproduct",

  
];

// Dynamic route patterns (like /edit/:id)
const dynamicNoHeaderFooterPatterns = [
  /^\/engedit\/[^/]+$/,
  /^\/spare-edit\/[^/]+$/,
  /^\/bldedit\/[^/]+$/,
   /^\/rentaledit\/[^/]+$/,
   /^\/Supplier\/orders\/[^/]+$/,
    /^\/supplier\/orders\/[^/]+$/,
      /^\/supplier\/singleorder\/[^/]+$/,

];

// Check whether to hide header/footer
const shouldHideHeaderFooter = () => {
  if (noHeaderFooterRoutes.includes(currentLocation.pathname)) {
    return true;
  }
  return dynamicNoHeaderFooterPatterns.some((pattern) =>
    pattern.test(currentLocation.pathname)
  );
};



  // useEffect(() => {
  //   const businessType = sessionStorage.getItem("businessType");
   
  //   if (!businessType || businessType.trim() === "") {
  //     setShowModal(true);
  //   } else {
  //     setShowModal(false);
  //     console.log("Business Type from session:", businessType); // Debugging log
  //     if (businessType === "Engineering" && location.pathname !== "/engineering-home") {
  //       navigate("/engineering-home");
  //     } else if (businessType === "Building" && location.pathname !== "/others-home") {
  //       navigate("/others-home");
  //     }
  //   }
  // },[location.pathname]);


  // const [showModal, setShowModal] = useState(true);
  useEffect(() => {
    if (businessType) {
      setShowModal(false);
      console.log("Business Type from session:", businessType);
 
    }
  }, [businessType, navigate, currentLocation.pathname]);

  const handleLoadingComplete = () => {
    setIsLoading(false);
    // You can redirect or show your main app here
    console.log('Loading complete!');
  };
  const handleBusinessSelection = (selectedType) => {
    sessionStorage.setItem("businessType", selectedType);
    setBusinessType(selectedType);
  };
   if (isLoading) {
    return (
      <LoadingPage 
        onLoadingComplete={handleLoadingComplete}
        logoSrc="/path/to/your/logo.png" // Replace with your logo path
      />
    );
  }


  return (
    <>
      {/* HomeDashboard always visible in the background */}
      {/* <HomeDashboard /> */}
      {/* {showModal && <HomeDashboard />} */}
      {/* Show modal only if required */}
      {/* {showModal && <PartsModal show={showModal} handleClose={() => setShowModal(false)}  onSelect={handleBusinessSelection} />} */}

      {/* Show routes only when modal is closed */}
        <ToastContainer />

      {showModal && <NewDashboard />}
      {showModal && (
        <PartsModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          onSelect={handleBusinessSelection}
        />
      )}

      {!showModal && (
        
        <>
              {/* {!noHeaderFooterRoutes.includes(currentLocation.pathname) && (
      <Header businessType={businessType} />
    )} */}
    {/* {!shouldHideHeaderFooter() && <Header businessType={businessType} />} */}

          
          <Routes>
            {/* Spare Routes */}
            <Route path="/" element={<NewDashboard />} />
            {/* <Route path="/" element={<HomeDashboard />} /> */}
            <Route path="/category" element={<Category />} />
            <Route path="/subcategory" element={<SubCategory/>}/>
            <Route path="/product/list" element={<ProductCategory />} />
            <Route path="/product-details/:id" element={<Product />} />
            <Route path="/products" element={<SearchOption />} />
            <Route path="/productlist" element={<ProductList />} />


            <Route path="/singleproduct/:id" element={<SingleProduct />} />
            <Route path="/viewcart/:id" element={<ViewCart />} />
            <Route path="/delivery" element={<Delivery />} />
            <Route path="/about" element={<About />} />
            <Route path="/review" element={<CustomerReview />} />
            <Route path="/account" element={<AccountHome />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/orderlist" element={<Orders />} />
            <Route path="/order/:id" element={<OrderDetails />} />
            <Route path="/account/contact" element={<ContactInformation />} />
            <Route path="/account/payments" element={<PaymentOptions />} />
            <Route path="/account/transactions" element={<PaymentList />} />
            <Route path="/account/history" element={<PurchaseHistory />} />
            <Route path="/account/order" element={<PurchaseOrder />} />
            <Route path="/account/order/pdf" element={<OrderPdf />} />
            <Route path="/whole-products" element={<Products />} />


            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgot" element={<ForgotPswd />} />


            {/* Engineering Routes */}
            <Route path="/engineering-home" element={<NewEngineeringHome />} />
            {/* <Route path="/engineering-home" element={<EngineeringHome />} /> */}
            <Route path="/engineering/productlist" element={<EngProductList />} />
            <Route path="/engineering/category" element={<EngineeringCategory />} />
            <Route path="/engineering/subcategories" element={<EngineeringSubcategory/>} />
            <Route path="/engineering/product/single/:id" element={<EngSingleProduct />} />

            {/* Rental Routes */}
            <Route path="/rental-home" element={<NewRentalHome/>} />
            {/* <Route path="/rental-home" element={<RentalHome/>} /> */}
            <Route path ="/rental/category" element={<RentalCategory/>}/>
            <Route path="/rental/products" element={<RentalProductList/>} />
            <Route path="/rental/subcategories" element={<RentalSubCategory/>} />
            <Route path="/rental/product/single/:id" element={<RentalSingleProductPage/>} />

            {/* Building Routes */}
            <Route path="/others-home" element={<BuildingHome />} />
            {/* <Route path="/others-home" element={<OtherHome />} /> */}
            <Route path="/others/products" element={<OthersProductList />} />
            <Route path="/others/subcategories" element={<SubcategoryPage/>} /> 

            <Route path="/others/product/single/:id" element={<OthersSingleProduct />} />
            <Route path="/others/category"  element={<OtherCategory/>} />
            

            {/* supplier */}
            <Route path="/SupplierDashboard" element={<SupplierDashboard/>}/>
            <Route path="/SupplierProducts" element={<SupplierProducts/>}/>
            <Route path="/SupplierReports" element={<SupplierReports/>}/>
            <Route path="/SupplierPayments" element={<SupplierPayments/>}/>
            <Route path="/Supplier/orders/:type" element={<SupplierOrdersPage />} />
            <Route path="/SupplierOrders" element={<SupplierOrders />} />
            <Route path="/supplier/singleorder/:orderId" element={<SupplierSingleOrder />} />   
            
            <Route path="/supplier/payments-list" element={<SupplierPaymentList />} />         
            <Route path="/productReports" element={<ProductReports />} />
            <Route path="/SupplierReturns" element={<SupplierReturns />} />
            <Route path="/CustomerReports" element={<CustomerReports />} />

            <Route path="/signup-supplier" element={<SupplierSignup />} />
            <Route path="/login-supplier" element={<SupplierLogin />} />
            <Route path="/engproduct" element={<CreateEngProduct/>}/>
            <Route path="/spareproduct" element={<CreateSpareProduct/>}/>
            <Route path="/bldproduct" element={<CreateBldProduct/>}/>
            <Route path="/rentalproduct" element={<CreateRentalProduct/>}/>
            <Route path="/rentaledit/:id" element={<RentalEdit/>}/>
            <Route path="/engedit/:id" element={<EngEdit/>}/>
            <Route path="/spare-edit/:id" element={<SpareEdit/>}/>
            <Route path="/bldedit/:id" element={<BldEdit/>}/>








 
\


           
           
          </Routes>
          {/* {!noHeaderFooterRoutes.includes(currentLocation.pathname) && <Footer />} */}
          {!shouldHideHeaderFooter() && <Footer />}
        </>
      )}
      
    </>
  );
}


export default App;
